module.exports = __webpack_public_path__ + "img/tool.59040743.svg";